import React from "react";
import styled from '@emotion/styled';
import { Box } from "@mui/material";

const DivRow = styled(Box)(({  gap, justifyContent, margin, alignItems, marginBottom, marginTop, marginRight, marginLeft, theme, height }) => ({
  display: "flex", 
  flexDirection: "row",
  alignItems: alignItems || "center",
  gap: gap || 0,
  justifyContent: justifyContent || "flex-start",
  margin: margin !== undefined ? theme.spacing(margin) : 0,
  marginBottom: marginBottom !== undefined ? theme.spacing(marginBottom) : undefined,
  marginTop: marginTop !== undefined ? theme.spacing(marginTop) : undefined,
  marginRight: marginRight !== undefined ? theme.spacing(marginRight) : undefined,
  marginLeft: marginLeft !== undefined ? theme.spacing(marginLeft) : undefined ,
  height: height || ''
}));

export default function ContainerRow({ children, gap, justifyContent, margin, alignItems, marginBottom, marginRight, marginTop, marginLeft, height, ...props }) {
  return (
    <DivRow  
    gap={gap} 
    justifyContent={justifyContent} 
    margin ={margin} 
    marginBottom={marginBottom} 
    marginTop={marginTop} 
    marginLeft={marginLeft}
    marginRight={marginRight}
    height={height}
    alignItems={alignItems} {...props}>
      {children}
    </DivRow>
  );
}